import React, { ReactNode, useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Header } from "../../common/headers"
import MatrixSelection from "../../common/pricing/add-item-modal/components/MatrixSelection"
import { ToggleWithBackdrop } from "../../common/toggle"
import { InventorySectionProps } from "../../common/types/inventory"
import AdjustmentListingPerStockLocation from "../../inventory/components/AdjustmentListingPerStockLocation"
import ProductInventoryQuantities from "../../inventory/components/ProductInventoryQuantitiesListing"
import { Guard, Permissions } from "../../role/Guard.jsx"
import IntlProps from "../../state/helpers/IntlProps"
import { InventoryLocationAction } from "../../state/inventory/location/actions"
import { InventoryLocationSelector } from "../../state/inventory/location/selectors"
import Product from "../../state/product/Product"
import { PRODUCT_TYPE } from "../../state/product/Types"
import { ProductAction } from "../../state/product/actions"
import { VariantsIds } from "../../state/product/pricingbrackets/PricingBrackets"
import { ProductSelector } from "../../state/product/selectors"
import { getProductQuantities } from "../../utils/inventory/utils"
import { PRODUCT_INVENTORY_SECTION_MESSAGES } from "../../utils/product"
import { ProductSupplierCostListing } from "../components"
import { AddProductSupplierModal } from "../modal"

export const InventorySection = (props: InventorySectionProps & IntlProps) => {
    const isEnabled = useSelector(ProductSelector.isTackingInventory)
    const [modal, setModal] = useState<ReactNode>()
    const [isLoading, setIsLoading] = useState(true)
    const [variantIds, setVariantIds] = useState(props.product?.attributes.matrix?.attributes.items?.map(i => {
        return {
            variantId: i.attributes.productId, 
            variantName: i.attributes.product?.attributes.title
        }
    }))

    const dispatch = useDispatch()
    const locationListing = useSelector(InventoryLocationSelector.getListing)

    useEffect(() => {
        if (locationListing.length === 0 && isLoading) {
            dispatch(InventoryLocationAction.fetchListing())
            setIsLoading(false)
        }
    }, [])

    const openAddSupplierModal = () => {
        setModal(
            <AddProductSupplierModal
                onCloseCallback={() => setModal(null)}
            />
        )
    }

    const onToggleChange = (isToggled: boolean) => {
        dispatch(ProductAction.patch({
            inventoryTracking: isToggled
        }))
    }
    return (
        <div>
            {modal}
            {Guard.isAuthorized(Permissions.AccessInventory) && !isEnabled &&
                <div className="pt-4">
                    <Header title={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES["header"])}/>
                    <ToggleWithBackdrop
                        onChangeCallback={onToggleChange}
                        isEnabled={isEnabled}
                        title={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES["toggleText"])}
                        description={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES["toggleDescription"])}
                    />
                </div>
            }
            {isEnabled && locationListing.length > 0 &&
                <>
                    {props.product?.attributes.type == PRODUCT_TYPE.MATRIX_PARENT &&
                    <MatrixSelection
                        product={new Product(props.product)}
                        onSelectedOptionIdsChange={(productIds) => {
                            setVariantIds(productIds)
                        }}
                        hideIcon={true}
                    />}
                
                    <div className={"pt-4 pb-2"}>
                        <Header title={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES["header_quantity_per_location"])}/>
                    </div>

                    <ProductInventoryQuantities
                        product={props.product}
                        locations={locationListing}
                        productQuantities={getProductQuantities(props.product)}
                        variantIds={variantIds as VariantsIds[] || []}
                    />

                    <div className={"pt-4 pb-2 d-flex justify-content-between"}>
                        <Header title={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES.header_supplier_cost)}/>

                        <Button variant={"primary"} onClick={openAddSupplierModal}>
                            {props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES.button_add_supplier_cost)}
                        </Button>
                    </div>

                    <ProductSupplierCostListing/>
                    
                    <div className={"pt-4 pb-2"}>
                        <Header title={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES["header_adjustments"])}/>
                    </div>

                    <AdjustmentListingPerStockLocation
                        productId={props.product.id || ""}
                        product={props.product}
                        variantIds={variantIds?.map(v=>v.variantId) || []}
                        locationId={locationListing[0]?.id || ""}
                    />

                    {Guard.isAuthorized(Permissions.AccessInventory) &&
                                    <div className="pt-3">
                                        <Header title={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES["header"])}/>
                                        <ToggleWithBackdrop
                                            onChangeCallback={onToggleChange}
                                            isEnabled={isEnabled}
                                            title={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES["toggleText"])}
                                            description={props.intl.formatMessage(PRODUCT_INVENTORY_SECTION_MESSAGES["toggleDescription"])}
                                        />
                                    </div>
                    }
                </>
            }


        </div>
    )
}


// WEBPACK FOOTER //
// ./src/product/sections/InventorySection.tsx